import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(5).addClass("active");
// 人才培养
$(".construction ul li").eq(0).addClass("active");
$(".construction .pic img").eq(0).addClass("active");
$(".construction ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".construction .pic img").eq(index).addClass("active").siblings().removeClass("active");
})


// 培训体系
var swiper = new Swiper(".train .mySwiper", {
    slidesPerView: "auto",
    spaceBetween: 130,
    pagination: {
        el: ".train .swiper-pagination",
        //自定义分页器样式
        type:"custom",
        renderCustom: function (swiper, current, total) {
            var dangqian = document.querySelector(".train .dangqian")
            var zongshu = document.querySelector(".train .zongshu")
            if(current<=9){
                current = "0"+current
            }else{
                current = current
            }
            if(total<=9){
                total = "0"+total
            }else{
            total = total
            }
            dangqian.innerText = current
            zongshu.innerText = total
        }
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            spaceBetween: 10,
           
        },
        768: { //当屏幕宽度大于等于768 
            spaceBetween: 80,
            
        },
        1280: { //当屏幕宽度大于等于1280
            spaceBetween: 130,
           
        }
    },
  });